import React, { useRef } from "react";
import { useUscLabel } from "../../../../utils/labels";
import { useUscSelector } from "../../../../redux/store";
import UscInsurancePanel from "../../common/basket/UscInsurancePanel";
import useUscInsuranceCalculatorButton from "../../../../hooks/uscUscInsuranceCalculatorButton";
import Icon from "../../../../../shared-components/lexus/styles/atoms/Icon";
import IconInsurance from "../../assets/visuals/insurance.svg";
import Text from "../../../../../shared-components/lexus/styles/atoms/Text";
import * as Styles from "../../common/ServicesWithDetailsList.styles";
import { trackCta, uscStepTrackingLocationMap } from "../../../../utils/tracking";

const InsuranceService = (): JSX.Element => {
    const detailsRef = useRef<HTMLDetailsElement>(null);
    const vehicle = useUscSelector((state) => state.vehicle);
    const insuranceIsActive = useUscSelector((state) => !!state.insurance.quote);
    const step = useUscSelector((state) => state.nav.step);
    const trackingLocation = uscStepTrackingLocationMap[step];

    const [editDetailsLabel, showDetailsLabel, titleLabel] = useUscLabel([
        "uscServicesInsuranceEditDetails",
        "uscServicesInsuranceShowDetails",
        "uscServicesInsuranceTitle",
    ]);

    const { showInsuranceCalculator } = useUscInsuranceCalculatorButton();

    return (
        <details ref={detailsRef} open={insuranceIsActive || undefined}>
            <summary
                aria-label={titleLabel}
                onClick={() => {
                    trackCta("insurance-calculator", trackingLocation, vehicle.type);
                    showInsuranceCalculator();

                    // If `insuranceIsActive` isn't active the details component should be closed
                    if (!insuranceIsActive) {
                        detailsRef?.current?.setAttribute("open", "false");
                    }
                }}
            >
                <div>
                    <Styles.MobileIconWrapper>
                        <IconInsurance />
                    </Styles.MobileIconWrapper>
                    <Text tag="h3" variant="h6">
                        {titleLabel}
                    </Text>
                </div>
                <Styles.FakeButton aria-hidden="true">
                    <Styles.ButtonIconWrapper>
                        <Icon variant="plus" />
                    </Styles.ButtonIconWrapper>
                    <Styles.ButtonText>{insuranceIsActive ? editDetailsLabel : showDetailsLabel}</Styles.ButtonText>
                </Styles.FakeButton>
            </summary>
            {insuranceIsActive && <UscInsurancePanel trackingLocation={trackingLocation} />}
        </details>
    );
};

export default InsuranceService;
